import { useGenericModal } from '..';
import { PublishModal, PublishModalProps } from './publish-modal';

export const usePublishModal = (props: Partial<PublishModalProps>) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const PublishModalComponent = (
    <PublishModal {...props} modalRef={modalRef} onClose={closeModal} />
  );
  return {
    modalRef,
    openModal,
    closeModal,
    publishModal: PublishModalComponent,
  };
};
